import { goBack, push } from 'connected-react-router'
import React, { FC, useEffect, useMemo, useState } from 'react'
import { isFulfilled, isRejected } from '@reduxjs/toolkit'

import CustomButton from '../../UI/Buttons/CustomButton'
import SchedulePostModal from '../../Calendar/ModalSchedulePost'
import ModalSendToApproval from '../SendToApproveModal'
import SkipApprovalModal from '../SkipApprovalModal';
import HashtagListModal from '../HashtagListModal';

import DraftIcon from '../../UI/Icons/statuses/Draft'
import PendingApprove from '../../UI/Icons/statuses/PendingApprove'
import WaitingIcon from '../../UI/Icons/statuses/Waiting'
import PublishIcon from '../../UI/Icons/statuses/Publish'
import CircularArrow from '../../UI/Icons/CircularArrow'

import { useDispatch, useSelector } from '../../../store'
import { showSuccessModalAction, openSchedulePostModal } from '../../../store/application/slice'
import {
  setPostsForApprovalAction,
  toggleIsOpenAprrovalModalAction
} from '../../../store/modal/approvalPost/slice'

import {
  updatePostSocialsThunk,
  savePostAsDraftAndScheduleThunk,
  startNextApprovalRoundThunk,
  publishPostManuallyThunk,
  adminPublishPostManuallyThunk,
  getPostApprovalInfoThunk,
  getPostThunk,
} from '../../../store/managePost/thunks'

import {
  getSchedulesThunk,
  TGetSchedulesData
} from '../../../store/calendar/thunks'

import './Header.scss'
import { setDateAction, setTimeAction, setSelectedSocialAction, setSelectedPostSocialIdAction,setPostDetails,resetManagePostStateAction  } from '../../../store/managePost/slice'
import { APPROVAL_TYPE, POST_SOCIAL_STATUS, POST_STATUS, SOCIAL_NETWORK } from '../../../models/post'
import './Header.scss'
import { generatePath, useParams } from 'react-router'
import { AUTH_ROUTE } from '../../../pages/App/routes'
import { TPostForApproval } from '../../../store/managePost/newTypes'
import { useToasts } from 'react-toast-notifications'
import { TOAST_MESSAGE } from '../../UI/ToastNotification/ToastNotification'
import { defineAvailablePostsActions } from '../../../models/postStatuses'
import { addMinutes,parseISO,getUnixTime } from 'date-fns'
import { convertToLocalTime } from 'date-fns-timezone'
import { isAfter } from 'date-fns/esm'
import ConfirmPopup from '../../UI/ConfirmPopup'
import { SCHEDULE_ACTION_TYPES } from '../../../store/application/types'
import {
  hideTransparentPreloaderAction,
  showTransparentPreloaderAction
} from '../../../store/transparentPreloader/slice'
import { SETTING_NAME } from '../../../store/project/types'
import Roles from '../../../models/roles'
import { resetGridViewStateAction } from '../../../store/gridView/slice'
import { toggleIsSkipAprrovalModalAction, openApproverModalAction, updateSkipApproverAction } from '../../../store/modal/skipApprovalPost/slice';

interface HeaderCreationProps { }

const HeaderCreation: FC<HeaderCreationProps> = (props) => {
  const {
    selectedSocial,
    isSaveDraftProcess,
    location,
    project,
    post,
    schedule_id,
    postId,
    postSocials,
    postStatus,
    postSocialsApprovalPlan,
    selectedPostSocialId,
    user,
    isGettingPostError,
    isExistChanges,
    schedule,
    openApproveModal,
    skippedApprovals,
    checkedDate,
    postDetails,
    postCalendarSchedule
    } = useSelector((state) => ({
    selectedSocial: state.managePost.selectedSocial,
    isExistChanges: state.managePost.isExistChanges,
    isSaveDraftProcess: state.managePost.loaders.post.save,
    location: state.router.location,
    project: state.project.currentProject,
    schedule_id: state.managePost.latestSchedule.id,
    postId: state.managePost.post.id,
    postSocials: state.managePost.postSocials,
    postStatus: state.managePost.post.status,
    postSocialsApprovalPlan: state.managePost.approval.post_socials,
    post: state.managePost.post,
    selectedPostSocialId: state.managePost.selectedPostSocialId,
    schedule: state.managePost.latestSchedule,
    user: state.auth.user,
    isGettingPostError: state.managePost.isGettingPostError,
    openApproveModal: state.skipApproval.openApproveModal,
    skippedApprovals: state.skipApproval.skipped_approvals,
    checkedDate: state.managePost.latestSchedule.date,
    postDetails:state.managePost.postDetails,
    postCalendarSchedule:state.calendar.schedules,
    // todo isEditable social
  })) 
  let socialPostNavigation:number=0;
  let selectedSocialDetId:number;
  let selectedSocialDet:any;
  const dispatch = useDispatch()
  const { addToast } = useToasts()
  const { date: urlDate } = (location as any).query as { date: string | undefined }
  const [isShowLeaveConfirmation, setIsShowLeaveConfirmation] = useState<boolean>(false)
  const [isMoveNextPopup, setMoveNext] = useState<boolean>(false)
  const [isMovePreviousPopup, setMovePrevious] = useState<boolean>(false)
  const closeLeaveConfirmPopup = () => setIsShowLeaveConfirmation(false)
  const showLeaveConfirmPopup = () => {setIsShowLeaveConfirmation(true);setMoveNext(false);setMovePrevious(false);}
  const showMoveNextPopup = () => { if(isShowNextPost) {setMovePrevious(false);setMoveNext(true);}}
  const showMovePreviousPopup = () => {setMoveNext(false);setMovePrevious(true);}
  const [isContentManager, setIsContentManager] = useState<boolean>(false);

  let getDates:any = localStorage.getItem('startEndDates');
  let startDate:any='';
  let endDate:any='';
  let startDateFormat:any='';
  if(getDates !=null){
    getDates = JSON.parse(getDates);
     startDate = getDates[0].split("T");
     endDate = getDates[1].split("T");
  }else{
     startDateFormat = new Date().getFullYear()+'-'+('0'+String(new Date().getMonth() + 1)).slice(-2);
  }

  const payload: TGetSchedulesData = {
    id: project.id,
    start:(startDate[0])?startDate[0]:startDateFormat,
    end:(endDate[0])?endDate[0]:endDate
  }

  useEffect(() => {
    const currentProjectId:any = window.location.pathname.split('/')[1];   
    payload.id=currentProjectId;

    if (!(schedule.date && schedule.time) && urlDate) {
      const [date, time] = urlDate.split('T')
      dispatch(setDateAction(date))
      dispatch(setTimeAction(time))
    }
      const detailsinf= fechPost();
  }, [dispatch, urlDate])

  const fechPost =(status:boolean=true)=>{
    const currentProjectId:number = parseInt(window.location.pathname.split('/')[1]);  
    if(postCalendarSchedule.length<1 || !status || (currentProjectId!=project.id)){
      const detailsInf = dispatch(getSchedulesThunk(payload)).then(result=>{
        const resultDetails= result.payload.data.post_schedules;
        const arrayForSort = [...resultDetails];
          arrayForSort.sort(function(a:any, b:any) {
            var keyA = getUnixTime(parseISO(a?.datetime));
            var  keyB = getUnixTime(parseISO(b?.datetime));
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
          });
          dispatch(setPostDetails(arrayForSort))
      })
    }else{
      const arrayForSort = [...postCalendarSchedule];
      arrayForSort.sort(function(a:any, b:any) {
        var keyA = getUnixTime(parseISO(a?.datetime));
        var  keyB = getUnixTime(parseISO(b?.datetime));
        if (keyA < keyB) return -1;
        if (keyA > keyB) return 1;
        return 0;
      });
      dispatch(setPostDetails(arrayForSort))
    }
  }
  const isShowPostNavigation:boolean = (postDetails.length > 1) ? true : false;
  let postDetailsKeys = isShowPostNavigation ? Object.keys(postDetails) : [];
  const findPostInf:any = postDetails.find((post_inf:any) => post_inf.post_id === postId );
  let isShowNextPost:boolean = ((postDetails.indexOf(findPostInf) + 1) == postDetails.length) ? false : true;
  let isShowPreviousPost:boolean = ((postDetails.indexOf(findPostInf) - 1) <0) ? false : true;

  const isEditable = useMemo(() => {
    if (selectedPostSocialId && postSocials.length) {
      const postSocial = postSocials.find(({ id }) => id === selectedPostSocialId)!
      return (
        postSocial?.status === POST_SOCIAL_STATUS.STATUS_DRAFT ||
        postSocial?.status === POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION ||
        postSocial?.status === POST_SOCIAL_STATUS.STATUS_PENDING_INTERNAL_APPROVAL ||
        postSocial?.status === POST_SOCIAL_STATUS.STATUS_PENDING_EXTERNAL_APPROVAL ||
        postSocial?.status === POST_SOCIAL_STATUS.STATUS_SCHEDULED ||
        postSocial?.status === POST_SOCIAL_STATUS.STATUS_PENDING_PUBLISH
      )
    } else {
      return true
    }
  }, [selectedPostSocialId, postSocials])

  const isExistRevisionsPostSocial: boolean = useMemo(() => {
    const postSocial = postSocials.find(({ id }) => id === selectedPostSocialId)!
    if (postSocial) {
      return postSocial?.status === POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION
    }
    return false
  }, [selectedPostSocialId, postSocials])

  const moveToCalendar = () =>
    dispatch(
      push(
        generatePath(AUTH_ROUTE.CALENDAR+`?date=${checkedDate}`, {
          projectId: String(project?.id)
        })
      )
    )

  const  moveNextPostWithSave = async()=>{
      await saveOrUpdatePost().then(result=>{
        moveNextPost();
      });
  }
  const movePreviousPostWithSave =async() =>{
    await saveOrUpdatePost().then(result=>{
      movePreviousPost();
    });
  }

  const moveNextPost = async () => {
    socialPostNavigation = postDetails.indexOf(findPostInf) + 1;
    if (isShowNextPost) {
      isShowPreviousPost = true;
      let postInfDetails:any= postDetails[parseInt(postDetailsKeys[socialPostNavigation])];
      selectedSocialDetId =postInfDetails['post_id'];
      selectedSocialDet = postInfDetails["post_social"];
      postNavigation()
    }
  }

  const postNavigation = async () => {
    setMoveNext(false);
    setMovePrevious(false);
    setIsShowLeaveConfirmation(false);
    dispatch(showTransparentPreloaderAction())
    await dispatch(resetManagePostStateAction())
    await dispatch(resetGridViewStateAction())
    await dispatch(setSelectedSocialAction(selectedSocialDet))
    await dispatch(setSelectedPostSocialIdAction(selectedSocialDetId))
    await fechPost();
    await dispatch(
      push(
        generatePath(AUTH_ROUTE.MANAGE_POST, {
          projectId: project.id,
          social: `${selectedSocialDet}`
        }) + `?postId=${selectedSocialDetId}`
      )
    )
    const responseGetPost = await dispatch(getPostThunk(selectedSocialDetId))
    if (
      isFulfilled(responseGetPost) &&
      responseGetPost.payload.data.status !== POST_STATUS.STATUS_DRAFT &&
      responseGetPost.payload.data.status !== POST_STATUS.STATUS_TEMPORARY_DRAFT
    ) {
      const responseGetPostApprovalInfo = await dispatch(
        getPostApprovalInfoThunk(selectedSocialDetId)
      )
    }
    dispatch(hideTransparentPreloaderAction())
  }

  const movePreviousPost = () => {
    socialPostNavigation = postDetails.indexOf(findPostInf) - 1
    if (isShowPreviousPost) {
      isShowNextPost = true
      let postInfDetails:any= postDetails[parseInt(postDetailsKeys[socialPostNavigation])];
      selectedSocialDetId =postInfDetails['post_id'];
      selectedSocialDet = postInfDetails["post_social"];
      postNavigation()
    }
  }
  const resendToApproval = async () => {
    const updatePostSocialsResponse = await dispatch(updatePostSocialsThunk())
    if (updatePostSocialsResponse) {
      const socialsToFix = postSocials.filter(
        (social) => social.status === POST_SOCIAL_STATUS.STATUS_REQUIRES_REVISION
      )
      const masterContentSocialApproval = postSocialsApprovalPlan.find(
        (socialApproval) => socialApproval.is_master_content
      )
      const idsToFixes = masterContentSocialApproval
        ? [masterContentSocialApproval.id]
        : socialsToFix.map((social) => social.id)

      for (let id of idsToFixes) {
        await dispatch(startNextApprovalRoundThunk({ post_social_id: id }))
      }
      addToast(TOAST_MESSAGE.POST_SENT_FOR_APPROVAL, { appearance: 'success' })
    }
  }

  const savePostAsDraft = async () => {
    const savePostResponse = await dispatch(savePostAsDraftAndScheduleThunk())
    if (isFulfilled(savePostResponse)) {
      addToast(TOAST_MESSAGE.CHANGE_SAVED, { appearance: 'success' })
      await dispatch(
        push(
          generatePath(AUTH_ROUTE.MANAGE_POST, {
            projectId: project.id,
            social: selectedSocial || postSocials[0].social_network
          }) + `?postId=${savePostResponse.payload.id}`
        )
      )
      await fechPost(false);
    } else {
      addToast((savePostResponse as any)?.payload?.payload?.error?.message, { appearance: 'error' });
    }
    return savePostResponse
  }

  const saveOrUpdatePost = async () => {
    if (!defineAvailablePostsActions.updatePostSocials(postStatus)) return
    let result
    if (!postId) {
      result = await savePostAsDraft()
    } else {
      result = await dispatch(updatePostSocialsThunk())
      addToast(TOAST_MESSAGE.CHANGE_SAVED, { appearance: 'success' });
    }
    return result
  }

  useEffect(() => {
    if (openApproveModal) {
      sendToApproval()
    }
    dispatch(openApproverModalAction(false))
  }, [openApproveModal])

  useEffect(() => {
    const role_name = user?.projects?.find(v=>v.id === project.id)?.setting.find(v=>v.name === SETTING_NAME.CONTENT_MANAGER && v.value === 'true')?.name;
    if(role_name !== null && role_name === 'content-manager'){
      setIsContentManager(true);
    }
  }, [user]);

  const isAdmin = useMemo(() => (user?.agency_role === Roles.AGENCY_ADMIN || user?.agency_role === Roles.SUPER_ADMIN), [user])

  const isContentCreator = useMemo(() => user?.agency_role === Roles.CONTENT_CREATOR, [user])

  const haveContentManager = useMemo(
    () => 
      project.projectUsers
        .filter(
          ({ role ,setting}) =>
          (!!setting.find((val) => val.name === SETTING_NAME.CONTENT_MANAGER && val.value  == 'true'))
        )
    , [project]
  )

  const sendToApproval = async () => {
    let savePostResponse
    const aprrovalPost: TPostForApproval = {
      ...post,
      schedule,
      postSocials
    }

    savePostResponse = isExistChanges && (await saveOrUpdatePost())

    if (savePostResponse && isFulfilled(savePostResponse)) {
      aprrovalPost.id = savePostResponse.payload.id
    }

    if (!defineAvailablePostsActions.sendToApprove(postStatus, schedule) && !isExistRevisionsPostSocial && !isUnapproved) {
      dispatch(openSchedulePostModal(SCHEDULE_ACTION_TYPES.SCHEDULE_BEFORE_APPROVAL))
    } else {
      if(isAdmin && haveContentManager.length === 0 && internalApproversList.length === 0 && approversList.length >= 0){
        await dispatch(updateSkipApproverAction([APPROVAL_TYPE.TYPE_INTERNAL]));
      }
      dispatch(toggleIsOpenAprrovalModalAction())
      dispatch(setPostsForApprovalAction([aprrovalPost]))
    }
  }

  const publishPostManually = async () => {
    let data
    dispatch(showTransparentPreloaderAction())
    if (defineAvailablePostsActions.publishByAdmin(postStatus, user?.agency_role)) {
      await saveOrUpdatePost()
      data = await dispatch(adminPublishPostManuallyThunk())
    } else if (defineAvailablePostsActions.publishByContentManager(postStatus) && !!project.setting.find(setting => setting.name === SETTING_NAME.CONTENT_MANAGER && setting.value === 'true')) {
      await saveOrUpdatePost()
      data = await dispatch(adminPublishPostManuallyThunk())
    } else {
      data = await dispatch(publishPostManuallyThunk())
    }
    if (isFulfilled(data)) {
      addToast(TOAST_MESSAGE.THE_CONTENT_HAS_BEEN_SUCCESSFULLY_PUBLISHED, { appearance: 'success' })
      await dispatch(getPostApprovalInfoThunk(postId))
    } else if (isRejected(data)) {
      addToast(TOAST_MESSAGE.THE_CONTENT_HAS_NOT_BEEN_PUBLISHED, { appearance: 'error' })
    }
    dispatch(hideTransparentPreloaderAction())
  }

  const isAvailablePublishNow = useMemo(
    () =>
      defineAvailablePostsActions.publishNow(postStatus) ||
      defineAvailablePostsActions.publishByAdmin(postStatus, user?.agency_role) ||
      (defineAvailablePostsActions.publishByContentManager(postStatus) &&
        !!project.setting.find(setting => setting.name === SETTING_NAME.CONTENT_MANAGER && setting.value === 'true')),
    [postStatus, project]
  )

  const schedulePost = () => {
    const scheduleActionType = schedule_id
      ? SCHEDULE_ACTION_TYPES.SINGLE_SCHEDULE
      : SCHEDULE_ACTION_TYPES.SHEDULE_TO_ROUTE
    dispatch(openSchedulePostModal(scheduleActionType))
  }

  const isAllowShedulePost = useMemo(() => {
    const { datetime, timezone } = schedule
    let isAvailable = defineAvailablePostsActions.schedule(postStatus)
    if (!isAvailable && datetime && timezone) {
      const localTimeSchedule = convertToLocalTime(new Date(datetime), { timeZone: timezone })
      const availableDateForPosting = addMinutes(new Date(), 4)
      isAvailable =
        post.status === POST_STATUS.STATUS_SCHEDULED &&
        isAfter(availableDateForPosting, localTimeSchedule)
    }
    return isAvailable
  }, [schedule, postStatus])

  const isAvailableScheduleAndSkipApproval = useMemo(
    () =>
    defineAvailablePostsActions.scheduleAndSkipApproval(postStatus) && 
      (user?.agency_role === Roles.AGENCY_ADMIN || user?.agency_role === Roles.SUPER_ADMIN ||
        !!project.setting.find(setting => setting.name === SETTING_NAME.SKIP_APPROVAL_AND_SCHEDULE && setting.value === 'true' && postStatus))
    , [project, postStatus]
  )

  const scheduleAndSkipApproval = async () => {
    if(internalApproversList.length > 0 && approversList.length === 0 && !(isContentManager || isAdmin)){
      await dispatch(updateSkipApproverAction([APPROVAL_TYPE.TYPE_EXTERNAL]));
    } else if(isAdmin && haveContentManager.length === 0 && internalApproversList.length === 0 && approversList.length === 0) {
      await dispatch(updateSkipApproverAction([APPROVAL_TYPE.TYPE_INTERNAL, APPROVAL_TYPE.TYPE_EXTERNAL]));
    } else if(isAdmin && haveContentManager.length === 0 && internalApproversList.length === 0 && approversList.length > 0) {
      await dispatch(updateSkipApproverAction([APPROVAL_TYPE.TYPE_INTERNAL]));
    }
    dispatch(toggleIsSkipAprrovalModalAction());
  }

  const isUnapproved: boolean = useMemo(() => {
    const postSocial = postSocialsApprovalPlan.find(({ id }) => id === selectedPostSocialId)!
    if (postSocial) {
      return postSocial?.is_unapproved
    }
    return false
  }, [selectedPostSocialId, postSocialsApprovalPlan])
  
  const approversList = useMemo(() => project.projectUsers.filter(
    ({ role ,setting}) =>
    (role === Roles.EXTERNAL_APPROVER ) 
  ),[project.projectUsers])

  const internalApproversList = useMemo(() => project.projectUsers.filter(
    ({ role ,setting}) =>
    (role === Roles.INTERNAL_APPROVER ) 
  ),[project.projectUsers])

  // const sendToApprovalShow = useMemo(
  //   () =>
  //     (internalApproversList.length === 0 && approversList.length === 0 && (isContentManager || isAdmin)) 
  //   , [internalApproversList, approversList]
  // )

  const scheduleButtonName = useMemo(() => 
    (internalApproversList.length > 0 && approversList.length === 0 && !(isContentManager || isAdmin)) || 
    (isAdmin && haveContentManager.length === 0 && internalApproversList.length === 0 && approversList.length === 0)
  , [internalApproversList, approversList]);

  return (
    <>
      <div className='creation-header__back'>
        <CustomButton
          button='move'
          contentClass='arrow-left'
          onClick={isExistChanges ? showLeaveConfirmPopup : moveToCalendar}
        >
          <p>Back To Calendar</p>
        </CustomButton>
      </div> 
        
       { (isShowPostNavigation && postId!=null && postId>0)  && (
          <div className='postNavigation'>
              <div className='creation-previous'>
                <CustomButton
                  button='move'
                  contentClass='arrow-left'
                  onClick={isExistChanges ? showMovePreviousPopup : movePreviousPost}
                  disabled= {!isShowPreviousPost && isShowNextPost}
                >
                  Previous Post Group
                </CustomButton>
              </div>
              <div className='creation-pipe'>
              |
              </div>
              <div className={ (!isShowNextPost && isShowPreviousPost)?'creation-next diasbled' : 'creation-next'} 
              onClick={isExistChanges ? showMoveNextPopup : moveNextPost} >
                Next Post Group
                <CustomButton
                button='move'
                contentClass='arrow-right'
                disabled= {!isShowNextPost && isShowPreviousPost}
                > 
                </CustomButton>
              </div>
          </div>
       )}
      
      {!isGettingPostError && (
        <div className='creation-header__actions'>
          {isAvailablePublishNow && (<CustomButton
            disabled={!isAvailablePublishNow}
            onClick={publishPostManually}
            button='primary'
          >
            <PublishIcon /> Publish now
          </CustomButton>)}
          {isAllowShedulePost && (<CustomButton disabled={!isAllowShedulePost} onClick={schedulePost} button='subtle'>
            <WaitingIcon /> Change Schedule
          </CustomButton>)}
          {isEditable && (<CustomButton
            disabled={!isEditable}
            inProgress={isSaveDraftProcess}
            onClick={saveOrUpdatePost}
            button='subtle'
          >
            {!isSaveDraftProcess && <DraftIcon />} {!!postId ? 'Save' : 'Save as draft'}
          </CustomButton>)}

          {isAvailableScheduleAndSkipApproval && (postStatus === POST_STATUS.STATUS_TEMPORARY_DRAFT ||
            postStatus === POST_STATUS.STATUS_DRAFT || isUnapproved || isExistRevisionsPostSocial) && (
                <CustomButton onClick={scheduleAndSkipApproval} disabled={ !isAvailableScheduleAndSkipApproval } button='primary'>
                  <WaitingIcon /> { scheduleButtonName ? 'Schedule' : 'Schedule and Skip Approval' }
                </CustomButton>)}

          {postStatus === POST_STATUS.STATUS_TEMPORARY_DRAFT ||
            ((postStatus === POST_STATUS.STATUS_DRAFT || isUnapproved || isExistRevisionsPostSocial) && postStatus !== POST_STATUS.STATUS_ON_PUBLISHING && postStatus !== POST_STATUS.STATUS_SCHEDULED && (
              <CustomButton onClick={sendToApproval} button='primary'>
                {isExistRevisionsPostSocial ? <><CircularArrow /><span>Resend to approval</span></> : <><PendingApprove /><span>Send to approval</span></>}
              </CustomButton>
            ))}
          {/* {isExistRevisionsPostSocial && (
            <CustomButton onClick={() => resendToApproval()} button='primary'>
              <CircularArrow /> Resend to approval
            </CustomButton>
          )} */}
        </div>
      )}

      <ConfirmPopup
        onClose={closeLeaveConfirmPopup}
        onConfirm={moveToCalendar}
        isModalOpen={isExistChanges && (isShowLeaveConfirmation && !isMoveNextPopup && !isMovePreviousPopup ) }
      >
        Are you sure you want to leave without saving your content?
      </ConfirmPopup>
      <ConfirmPopup
        onClose={moveNextPost}
        onConfirm={moveNextPostWithSave}
        isModalOpen={isExistChanges && ( (isMoveNextPopup && isShowNextPost) && !isShowLeaveConfirmation && !isMovePreviousPopup)}
      >
        Would you like to save your content before leaving?
      </ConfirmPopup>
      <ConfirmPopup
        onClose={movePreviousPost}
        onConfirm={movePreviousPostWithSave}
        isModalOpen={isExistChanges && (isMovePreviousPopup && !isMoveNextPopup && !isShowLeaveConfirmation)}
      >
        Would you like to save your content before leaving?
      </ConfirmPopup>
      <SkipApprovalModal />
      <ModalSendToApproval />
      <SchedulePostModal />
      <HashtagListModal/>
    </>
  )
}

export default HeaderCreation
